module.exports = __webpack_public_path__ + "img/pethouse42.9ad70f4d.jpg";